import { SortableAccount } from "./types";

function getAccountRank<T extends SortableAccount>(account: T): number {
  switch (account.type) {
    case "CREDIT_CARD": {
      // Open credit card
      if (account.status === "OPEN" && account.links.length > 0) {
        return 1;
      }

      // Disabled credit card
      if (account.links.length === 0) {
        return 2;
      }

      // Closed credit card
      if (account.status === "CLOSED") {
        return 3;
      }

      return 4;
    }

    case "PERSONAL_LOAN": {
      return 10;
    }

    default: {
      return Infinity;
    }
  }
}

export function sortAccounts<T extends SortableAccount>(accounts: T[]): T[] {
  return accounts.sort((account1, account2) => {
    const rank1 = getAccountRank(account1);
    const rank2 = getAccountRank(account2);

    if (rank1 < rank2) {
      return -1;
    }

    if (rank1 > rank2) {
      return 1;
    }

    if (account1.productName && account2.productName) {
      return account1.productName <= account2.productName ? -1 : 1;
    }

    return -1;
  });
}
